import React from 'react'
import profileSchema from '../../yup/profile/profileSchema'
import { Button, ErrorForm, InputForm, PopUpGeneric } from '../../components'
import { useLocation, useNavigate } from 'react-router-dom'
import { Controller, useForm } from 'react-hook-form'
import { useYupValidation } from '../../hooks'
import { IProfileEdit } from '../../interfaces'
import { confirmAlert } from 'react-confirm-alert'
import { errorHandler, ProfileService } from '../../services'
import { AuthContext, AuthContextType } from '../../contexts/authContext'
import { toast } from 'react-toastify'
import { SpinnerLoader } from '../../assets/icons'
import { cpfMask, unMaskInputs } from '../../utils'

export default function EditProfile(): React.ReactElement {
    const location = useLocation()
    const { setDataUser, getUserInfo } = React.useContext(AuthContext) as AuthContextType
    const [isLoading, setIsLoading] = React.useState(false)

    const navigate = useNavigate()
    const {
        handleSubmit,
        control,
        formState: { errors },
    } = useForm<IProfileEdit>({
        resolver: useYupValidation(profileSchema),
    })

    async function submit(dataUser: IProfileEdit): Promise<void> {
        setIsLoading(true)
        try {
            const profileContext = await ProfileService.putDataUser({ ...dataUser, cpf: unMaskInputs(dataUser.cpf) })
            setDataUser({
                email: dataUser.email,
                name: dataUser.name,
                cpf: dataUser.cpf,
                imageUrl: getUserInfo()?.imageUrl || '',
            })
            toast(profileContext.message, { type: 'success' })
            navigate('/profile')
        } catch (err) {
            toast(errorHandler(err).message, { type: 'error' })
        } finally {
            setIsLoading(false)
        }
    }

    function popUpConfirm(values: IProfileEdit): void {
        confirmAlert({
            customUI: ({ onClose }) => (
                <PopUpGeneric
                    onConfirm={() => {
                        submit(values)
                        onClose()
                    }}
                    onCancel={onClose}
                    title={'Deseja salvar as alterações?'}
                />
            ),
        })
    }

    return (
        <div className="edit-profile_page">
            <form className="data-edit-user" onSubmit={handleSubmit(popUpConfirm)}>
                <div className="box-controller">
                    <Controller
                        name="name"
                        defaultValue={location.state.name}
                        control={control}
                        render={({ field: { value, onChange } }) => {
                            return <InputForm placeholder="Nome" label="Nome " name="name" type="text" value={value} onChange={onChange} />
                        }}
                    />
                    <ErrorForm error={errors.name?.message} />
                </div>
                <div className="box-controller">
                    <Controller
                        name="email"
                        defaultValue={location.state.email}
                        control={control}
                        render={({ field: { value, onChange } }) => {
                            return <InputForm placeholder="E-mail" label="E-mail " name="email" type="email" value={value} onChange={onChange} />
                        }}
                    />
                    <ErrorForm error={errors.email?.message} />
                </div>
                <div className="box-controller">
                    <Controller
                        name="cpf"
                        defaultValue={location.state.cpf}
                        control={control}
                        render={({ field: { value, onChange } }) => {
                            return <InputForm placeholder="CPF" label="CPF " name="cpf" type="text" value={cpfMask(value)} onChange={onChange} />
                        }}
                    />
                    <ErrorForm error={errors.cpf?.message} />
                </div>
                <div className="box-controller">
                    <Controller
                        name="currentPassword"
                        control={control}
                        defaultValue={''}
                        render={({ field: { value, onChange } }) => {
                            return (
                                <InputForm
                                    type="password"
                                    placeholder="Senha atual"
                                    label="Senha atual "
                                    name="currentPassword"
                                    value={value}
                                    onChange={onChange}
                                />
                            )
                        }}
                    />
                    <ErrorForm error={errors.currentPassword?.message} />
                </div>

                <div className="box-buttons">
                    <Button placeholder="Cancelar" type="button" onClick={() => navigate(-1)} />
                    <Button placeholder="Salvar Alterações" type="submit" />
                </div>
            </form>
            {isLoading ? (
                <div className="loader-page">
                    <SpinnerLoader />
                </div>
            ) : (
                <></>
            )}
        </div>
    )
}
